module.exports = __webpack_public_path__ + "static/gallery06-62279719249156dad491cbb1376b653a.jpg";